import {DatePipe} from "@angular/common"
import {environment} from "src/environments/environment"
import {MachineModel} from "../machine/models/machine.model";

export const MachineTranslations = {
  entityName: 'Macchina',
  fields: {
    uid: 'UID',
    group: 'Gruppo',
    description: 'Descrizione',
    family: 'Famiglia',
    enabled: 'Attiva',
    removed: 'Rimosso',
    lampHours: 'Ore Lampada',
    lampHoursEmailEnabled: 'Invio email ore lampada',
    periodFrom: 'Periodo inizio',
    periodTo: 'Periodo fine',
    params: 'Parametri aggiuntivi',
    projector: 'Proiettore',
    schedulerEnabled: 'Scheduler',
    ipAddress: 'Indirizzo IP',
    macAddress: 'Indirizzo MAC',
    networkInfoLastUpdate: 'Data di ultima rilevazione degli IP',
    associatedMachines: 'Macchine associate',
    profile: 'Profilo',
    games: 'Giochi',
    deletedAt: 'Eliminata il',
  }
}

export const MachineFullTableConfig = {
  ignoreGeneratedColumns: false,
  allowedColumns: [
    'uid',
    'group',
    'description',
    'family.name',
    'projector',
    'lampHours',
    'enabled',
    'lastRequest.createdAt',
    'schedulerEnabled',
  ],
  columns: [
    {
      def: "enabled",
      maxWidth: '60px',
    },
    {
      def: "lampHours",
      maxWidth: '130px',
    },
    {
      def: "uid",
      minWidth: '380px',
    },
    {
      def: "family.name",
      name: 'Famiglia',
      value: (element: MachineModel) => element.family?.enabled ? element.family.name : '',
      sort: true,
      filter: true,
      type: 'string',
    },
    {
      def: "uid",
      name: "UID",
      value: (element: MachineModel) => element.uid,
      sort: true,
      type: 'string',
    },
    {
      def: "lastRequest.createdAt",
      name: "Ultima richiesta",
      value: (element: MachineModel) => element.lastRequest ? new DatePipe(environment.DATE_LOCALE).transform(
        element.lastRequest.createdAt,
        environment.DATE_TIME_FORMAT
      ) : '-',
      sort: true,
      type: 'date',
      filter: true,
    },
    {
      def: "schedulerEnabled",
      maxWidth: '80px',
    },
  ],
  join: [{field: 'lastRequest'}, {field: 'family'}],
  enableUrlQueryParams: true,
}

export const MachineDynamicFormConfig = {
  ignoreGeneratedForms: false,
  forms: [],
  readonly: false,
}
